export const useDefaultVariables = () => {
    const { $i18n } = useNuxtApp();
    const { currentCraftUri, getCurrentCraftUri } = useCraft();
    const route = useRoute();
    const siteHandle = computed(() => {
        return $i18n?.localeProperties?.value?.craftSiteHandle;
    });

    const variables = computed(() => {
        return {
            uri: currentCraftUri.value,
            siteHandle: siteHandle.value
        };
    });

    watch(() => route.path, () => {
        if (variables?.uri) {
            variables.uri = getCurrentCraftUri(route.path, toValue($i18n?.locale?.value));
        }
    });

    return { variables };
};
